
import { Component, Vue } from 'vue-property-decorator'
import { ValidationObserver } from 'vee-validate'
import {
  MachineContext,
  MachineStateType,
  ResendLastBookingConfirmationService,
} from './machine'
import { getResendLastBookingConfirmationFactory } from './inversify.config'

@Component<ResendConfirmationEmailMain>({
  components: { ValidationObserver },
  head: function () {
    return this.head()
  },
})
export default class ResendConfirmationEmailMain extends Vue {
  email = ''

  serviceFactory = getResendLastBookingConfirmationFactory()

  service: ResendLastBookingConfirmationService | null = null
  context: MachineContext | null = null
  state: MachineStateType | null = null

  head() {
    return {
      title: (this.$t('Resend confirmation email') +
        ' | Pitchup.com') as string,
      meta: [
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
        {
          hid: 'description',
          name: 'description',
          property: 'og:description',
          content:
            'Resend the confirmation email from your last booking on Pitchup.com to your email address.',
        },
      ],
    }
  }

  created() {
    const service = this.serviceFactory({
      email: this.email,
    }) as ResendLastBookingConfirmationService
    this.service = service
      .onTransition((state) => {
        this.state = state
        this.context = state.context
      })
      .start()
  }

  submit() {
    this.service?.send({ type: 'SUBMIT_FORM', email: this.email })
  }
}
